import React from "react";

// Shared card chrome: header (icon + title + optional badge), body, and an
// optional footer (left note + right actions).
const CardShell = ({
  icon,
  title,
  headerRight,
  footerLeft,
  footerRight,
  className = "",
  children,
}) => (
  <section className={`jd-card ${className}`.trim()}>
    <div className="jd-card-header">
      <div className="jd-card-title">
        {icon}
        <h5>{title}</h5>
      </div>
      {headerRight && <div className="jd-card-header-right">{headerRight}</div>}
    </div>
    {children && <div className="jd-card-body">{children}</div>}
    {(footerLeft || footerRight) && (
      <div className="jd-card-footer">
        <div className="jd-card-footer-left">{footerLeft}</div>
        {footerRight && (
          <div className="jd-card-footer-actions">{footerRight}</div>
        )}
      </div>
    )}
  </section>
);

export default CardShell;
